import React from 'react'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import './DataAnalysisPython.css'
import logoOfOurProject1 from '../Images/logoOfOurProject1.jpg'
import bootcamp1 from '../Images/bootcamp-1.jpg'
import bootcamp2 from '../Images/bootcamp-2.jpg'
import bootcamp3 from '../Images/bootcamp-3.jpg'
import bootcamp4 from '../Images/bootcamp-4.jpg'

const DataAnalysisPython = () => {

    const [searchQuery, setSearchQuery] = useState('');
    const [filteredCourses, setFilteredCourses] = useState([]);
    const [courses, setCourses] = useState([
        { id: 1, title: 'MLOps Pro Specialization', path: '/mlops' },
        { id: 2, title: 'Mastering Data Analysis with Python', path: '/DataAnalysisWithPython' },
        { id: 3, title: 'Mastering GenAI Specialisation', path: '/masteringGenAI' },
        { id: 4, title: 'Data Science Masterclass', path: '/datasciencemasterclass' },
        { id: 5, title: 'Advanced LLM Ops Specialization', path: '/advancedllm' }
        // Add more courses here or fetch from an API
    ]);

    const handleSearch = (e) => {
        const query = e.target.value.toLowerCase();
        setSearchQuery(query);

        // Filter the courses based on the search query
        if (query) {
            const filtered = courses.filter((course) =>
                course.title.toLowerCase().includes(query)
            );
            setFilteredCourses(filtered);
        } else {
            setFilteredCourses([]);
        }
    };


    useEffect(() => {
        const handleScroll = () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(element => {
                const position = element.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight) {
                    element.classList.add('show');
                }
            });
        };

        handleScroll(); // Trigger animation on load
        window.addEventListener('scroll', () => {
            const elements = document.querySelectorAll('.fade-in, .slide-in');
            elements.forEach(el => {
                const position = el.getBoundingClientRect().top;
                const windowHeight = window.innerHeight;

                if (position < windowHeight - 100) {
                    el.classList.add('show');
                } else {
                    el.classList.remove('show'); // Ensures animation triggers again when scrolling back
                }
            });
        });

        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <div className='container'>
            <nav className="navbar navbar-expand-lg bg-body-tertiary">
                <div className="container-fluid">
                    <a href='/'><img src={logoOfOurProject1} alt='logo' /></a>
                    {/* <a className="navbar-brand fw-bold" href="/">KOTI AI</a> */}
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-5">
                            <li className="nav-item me-3">
                                <a className="nav-link active fw-medium" aria-current="page" href="/">Home</a>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Courses</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="datasciencemasterclass">Data Science</a></li>
                                    <li><a className="dropdown-item" href="/dataAnalysisWithPython">Data Analysis</a></li>
                                    <li><a className="dropdown-item" href="/masteringandbuildingproduct">Mastering AI Product- Langchain & LangGraph</a></li>
                                    <li><a className="dropdown-item" href="/productmanagementinai">Product Management In AI</a></li>
                                    <li><a className="dropdown-item" href="/masteringGenAI">Mastering GenAI</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="/allcourses">More Courses</a></li>
                                </ul>
                            </li>
                            <li className="nav-item me-3">
                                <a className="nav-link fw-medium" href="#">Service</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="#">Product Development</a></li>
                                    <li><a className="dropdown-item" href="/trainingandworkshop">Training & Workshops</a></li>
                                    <li><a className="dropdown-item" href="#">Customer Success</a></li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link fw-medium" href="#">About</a>
                                <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <li><a className="dropdown-item" href="ourteam">Our Team</a></li>
                                    {/* <li><a className="dropdown-item" href="#">Mission & Vision</a></li> */}
                                    <li><a className="dropdown-item" href="#">Reviews</a></li>
                                    <li><hr className="dropdown-divider" /></li>
                                    <li><a className="dropdown-item" href="#contact-section">Contact Us</a></li>
                                </ul>
                            </li>
                        </ul>
                        {/* <form className="d-flex" role="search">
                            <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search" />
                            <button className="btn btn-outline-success" type="submit">Search</button>
                        </form> */}

                        <div className="search-bar-container" style={{ position: 'relative', width: '50%' }}>
                            <form className="d-flex" role="search" onSubmit={(e) => e.preventDefault()}>
                                <input
                                    className="form-control me-2"
                                    type="search"
                                    value={searchQuery}
                                    onChange={handleSearch}
                                    placeholder="Search for courses..."
                                    aria-label="Search"
                                    autoComplete="on"
                                />
                                <button className="btn btn-outline-success" type="submit">Search</button>

                                {/* Dropdown search results */}
                                {searchQuery && filteredCourses.length > 0 && (
                                    <div className="dropdown-search-results">
                                        <ul>
                                            {filteredCourses.map((course) => (
                                                <li key={course.id}>
                                                    <Link to={course.path} onClick={() => setSearchQuery('')}>
                                                        {course.title}
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                )}
                            </form>


                        </div>

                    </div>
                </div>
            </nav>
            <div className='container'>
                <img className='banner-set-1' alt="" data-hook="image-wrapper" src="https://static.wixstatic.com/media/f18369_956efaa403484768a72a76a38933c387~mv2.png/v1/fit/w_800,h_600,al_c,q_90/file.webp" loading="eager" />
            </div>

            <div className='about-course'>
                <h2 className='fade-in'>About Program</h2>
                <p className='slide-in'>
                    Join our <span className="highlight-gradient">Mastering Data Analysis With Python</span> course to enhance your data analysis skills and boost your career opportunities in the booming field of data science. This course is designed for working professionals, freshers, and senior leadership looking to acquire advanced knowledge in Python for data analysis. Throughout the 3 learning units and 15 comprehensive steps, you will delve into essential data analysis concepts, learn how to clean and preprocess data, perform advanced data manipulation, visualize data effectively, and interpret results with confidence. By the end of the course, you will have the expertise to conduct data analysis projects independently and make informed business decisions based on data-driven insights.
                </p>

                <a href='/courseregistration'>
                    <button className='p-2 w-25 m-2 fw-bold btn btn-outline-primary float-end'>Apply Now</button>
                </a>

                <br/>
                <hr/>

                {/* <div className='container fade-in'>
                    <iframe width="760px" height="480px" src="https://forms.office.com/Pages/ResponsePage.aspx?id=czK0oudyEEK_zLjRxAHO90bA4f_svI9JsL3skoUaXAVUMVZFMTFGRkYwOFJUUElUM0tUT1dFSklJQS4u&embed=true" style={{ border: "none", maxWidth: "100%", MaxHeight: "100vh" }} allowfullscreen webkitallowfullscreen mozallowfullscreen msallowfullscreen frameborder="0" marginwidth="0" marginheight="0"> </iframe>
                </div> */}

                <br />
                <br />
                <br />
                <hr />
            </div>
            <div className='p-5 fade-in'>
                <h5>Our Online Bootcamp</h5>
                <span className='font-size'>An immersive learning experience</span>
            </div>
            <br />
            <div class="card-group p-3 slide-in">
                <div class="card me-3">
                    <img src={bootcamp1} alt='bootcampbanner-1' />
                    <div class="card-body">
                        <h5 class="card-title">Develop skills for real career growth</h5>
                        <p class="card-text">Cutting-edge curriculum designed in guidance with industry and academia to develop job-ready skills</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>
                <div class="card me-3">
                    <img src={bootcamp2} alt='bootcampbanner-2' />
                    <div class="card-body">
                        <h5 class="card-title">Learn from experts active in their field, not out-of-touch trainers</h5>
                        <p class="card-text">Leading practitioners who bring current best practices and case studies to sessions that fit into your work schedule.</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>
                <div class="card me-3">
                    <img src={bootcamp3} alt='bootcampbanner-3' />
                    <div class="card-body">
                        <h5 class="card-title">Learn by working on real-world problems</h5>
                        <p class="card-text">Capstone projects involving real world data sets with virtual labs for hands-on learning</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>
                <div class="card">
                    <img src={bootcamp4} alt='bootcampbanner-4' />
                    <div class="card-body">
                        <h5 class="card-title">Structured guidance ensuring learning never stops</h5>
                        <p class="card-text">24x7 Learning support from mentors and a community of like-minded peers to resolve any conceptual doubts</p>
                        <p class="card-text"><small class="text-body-secondary">Last updated 3 mins ago</small></p>
                    </div>
                </div>
            </div>

            <br />
            <br />

            <footer>
                <div className='footer p-4 bg-dark'>
                    <div className='d-flex justify-content-between'>
                        <div className='footer-social text-white'>
                            <h4>Follow us!</h4>
                            <br />
                            <div className='footer-social-links-1'>
                                <a href="https://www.facebook.com/imtusharchaudhary" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Facebook-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.Twitter.com/Tusharcofficial" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Twitter-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                                <a href="https://www.instagram.com/iamtusharchaudhry" target="blank"><img align="center" src="https://1000logos.net/wp-content/uploads/2017/02/Instagram-Logosu.png" alt="imtusharchaudhary" height="30" width="50" /></a>
                            </div>
                        </div>
                        <div className='AboutCompany text-white'>
                            <h4>Company</h4>
                            <p className='text-white-50'>About</p>
                            <p className='text-white-50'>Carrers</p>
                            <p className='text-white-50'>Newsroom</p>
                            <p className='text-white-50'>Alumni Speak</p>
                            <p className='text-white-50'>Grievance redreesal</p>
                            <p className='text-white-50'>Contact us</p>
                        </div>
                        <div className='WorkWithUs text-white'>
                            <h4>Work With Us</h4>
                            <p className='text-white-50'>Become an instructor</p>
                            <p className='text-white-50'>Blog as guest</p>
                        </div>
                        <div className='ForBusinesses text-white' id='contact-section'>
                            <h4>Contact Us</h4>
                            <p className='text-white-50'></p>
                            <p className='text-white-50'><i class="bi bi-phone"></i>&nbsp; Request a callback</p>
                            <p className='text-white-50'><i class="bi bi-telephone-plus-fill"></i>&nbsp; +91 8448-313599</p>
                            <p className='text-white-50'><i class="bi-envelope-fill"></i>&nbsp; info@kotiai.com</p>
                        </div>
                    </div>
                </div>
                <div className='footer-bottom'>
                    <p>© 2024 kotiai.com | Terms of Service | Privacy Policy</p>
                </div>
            </footer>
        </div>
    )
}

export default DataAnalysisPython